import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

function About() {
  return (
    <main className="about-page">
      <section className="about-hero">
        <div>
          <p className="eyebrow">About {siteConfig.brandName}</p>
          <h1>Small things on paper can hold a whole life.</h1>
          <p>We gather thoughtful tools for writing, drawing and journaling—objects that make ordinary moments feel worth noticing.</p>
        </div>
        <img src="/main/about-studio.jpg" alt="A warm creative desk with an open journal" width="1600" height="800" />
      </section>

      <section className="about-story page-shell section-space">
        <aside><p className="eyebrow">Our story</p><span>Since 2024<br />Hong Kong</span></aside>
        <div>
          <h2>A quiet corner for people who still love the sound of a page turning.</h2>
          <p>{siteConfig.displayName} began with a collection of notebooks, tape and pens, and a simple wish: to make beautifully designed stationery easier to discover.</p>
          <p>We choose every piece for how it behaves in the hand—the tooth of the paper, the balance of a pen, the clean peel of a tape. The collection is small on purpose, so there is room to describe what makes each object useful and special.</p>
          <blockquote>“The whisper is the small sound between pen and paper—the moment a thought becomes visible.”</blockquote>
        </div>
      </section>

      <section className="about-values">
        <div className="page-shell">
          <article><span>01</span><h3>Personally considered</h3><p>Every object earns its place through good materials, thoughtful construction and genuine usefulness.</p></article>
          <article><span>02</span><h3>Made for daily life</h3><p>We favour pieces that become better through use, not things destined to stay untouched on a shelf.</p></article>
          <article><span>03</span><h3>Packed with care</h3><p>Orders are prepared by hand using restrained, recyclable packaging that protects without excess.</p></article>
        </div>
      </section>

      <section className="about-letter page-shell section-space">
        <div><p className="eyebrow">A note from the studio</p><h2>Welcome. Stay awhile.</h2></div>
        <div><p>I have kept journals since childhood—first about meals and songs, later about all the growing pains in between. Writing became a private conversation and stationery became the language around it.</p><p>This shop is an invitation to make your own meaningful connection with paper, however small or imperfect. Thank you for finding our corner of the internet.</p><p className="about-signature">— The {siteConfig.brandName} studio</p><Link className="text-link" to="/shop">Explore the collection <FiArrowRight /></Link></div>
      </section>
    </main>
  );
}

export default About;
